import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import apiClient from '../ApiClient/ApiClient';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


export default function ComapnyBasicSet() {
    const columns = [
        {
            field: 'action',
            headerName: '操作',
            width: 80,
            renderCell: (params) => (
                // eslint-disable-next-line react/button-has-type
                <Button onClick={() => destorySubmit(params.row.manufacturer_Seq)}>刪除</Button>
              )
        },       
        { field: 'id', headerName: 'ID', width: 80 },
        {
          field: 'manufacturer_Seq',
          headerName: '廠商編號',
          width: 100,
          editable: true,
        },
        {
            field: 'manufacturer_AbbreviationName',
            headerName: '廠商簡寫',
            width: 80,
            editable: true,
        },
        {
            field: 'manufacturer_FullName',
            headerName: '廠商全名',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_CompanyPhone',
            headerName: '公司電話',
            width: 120,
            editable: true,
        },
        {
            field: 'Manufacturer_CompanyFax',
            headerName: '公司傳真',
            width: 120,
            editable: true,
        },
        {
            field: 'manufacturer_Email',
            headerName: 'Email',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_UniformNum',
            headerName: '統一編號',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_CityCode',
            headerName: '郵遞區號',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_FaxNum',
            headerName: '傳真號碼',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_BossName',
            headerName: '負責人名稱',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_ContactName',
            headerName: '聯絡人名稱',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_CompanyAddress',
            headerName: '公司地址',
            width: 150,
            editable: true,
        },
        {
          field: 'manufacturer_ShipAddress',
          headerName: '送貨地址',
          width: 150,
          editable: true,
        },
        {
            field: 'manufacturer_ShipAddress2',
            headerName: '送貨地址2',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_ShipAddress3',
            headerName: '送貨地址3',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_FactoryNum',
            headerName: '工廠電話',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_FactoryFax',
            headerName: '工廠傳真',
            width: 150,
            editable: true,
        },    
        {
            field: 'manufacturer_AccCode',
            headerName: 'AccCode',
            width: 150,
            editable: true,
        },
        {
            field: 'manufacturer_PayMent',
            headerName: '付款方式',
            width: 150,
            editable: true,
        },
        

    ];
    const [rows,setRows] = useState([])
    const [simple,setSimple] = useState('')
    const [name,setName] = useState('')
    const [person,setPerson] = useState('')
    const [manufacturer,setManufacturer] = useState({
        Id:0,
        Seq:'',
        BillNum:'',
        ComPhone:'',
        ComFax:'',
        EasyName:'',
        Boss:'',
        ComAddress:'',
        ComFullName:'',
        ContactPerson:'',
        AccCode:'',
        FacPhone:'',
        FacFax:'',
        PayWay:'',
        SendAddress:'',
        SendAddress2:'',
        SendAddress3:'',
        Email:'',
        Category:'',
    })

    const navigate = useNavigate();

    const CATEGORY_OPTIONS = [
        '相關企業','模具零件','原料供應商','設備或維修商',
        '客戶','協力廠','顧問公司','其他'
      ];
    useEffect(() => {
        const token = sessionStorage.getItem('jwtData');
        if (!token) {
            navigate('/login');
        }
    }, [navigate]);
    const fetchData = async () => {
        try {
          
          const response = await apiClient.get(`/Manufacturer/list`);
          // 檢查響應的結果，並設置到 state
          if (response.status === 200) {
            setRows(response.data.manufacturers);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
    };

    const fetchFilterData = async () => {
        try {
          // 使用 encodeURIComponent 来确保参数被正确编码
          const simpleEncoded = encodeURIComponent(simple);
          const nameEncoded = encodeURIComponent(name);
          const personEncoded = encodeURIComponent(person);
    
          const response = await apiClient.get(`/Manufacturer/filterlist?simpleName=${simpleEncoded}&name=${nameEncoded}&person=${personEncoded}`);
          // 检查响应的结果，并设置到 state
          if (response.status === 200) {
            setRows(response.data.manufacturers);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
    };
    


    useEffect(() => {
        // 定義非同步 function 來獲取數據
        fetchData();
    }, []); 

    const handleGetDetail = async (params) => {
        setManufacturer({
          Id: params.row.id, // 如果为 NULL，设置为空字符串
          Seq: params.row.manufacturer_Seq || "",
          BillNum: params.row.manufacturer_UniformNum || "",
          ComPhone: params.row.manufacturer_CompanyPhone || "",
          ComFax: params.row.manufacturer_CompanyFax || "",
          EasyName: params.row.manufacturer_AbbreviationName || "",
          Boss: params.row.manufacturer_BossName || "",
          ComAddress: params.row.manufacturer_CompanyAddress || "",
          ComFullName: params.row.manufacturer_FullName || "",
          ContactPerson: params.row.manufacturer_ContactName || "",
          AccCode: params.row.manufacturer_AccCode || "",
          FacPhone: params.row.manufacturer_FactoryNum || "",
          FacFax: params.row.manufacturer_FactoryFax || "",
          PayWay: params.row.manufacturer_PayMent || "",
          SendAddress: params.row.manufacturer_ShipAddress || "",
          SendAddress2: params.row.manufacturer_ShipAddress2 || "",
          SendAddress3: params.row.manufacturer_ShipAddress3 || "",
          Email: params.row.manufacturer_Email || "",
        });
    };
    const handleInputChange = (event, propertyName) => {
        const value = event.target.value;

        setManufacturer((prevData) => ({
            ...prevData,
            [propertyName]: value,
        }));
    };

    const categoryDisabled = Boolean((manufacturer.Seq ?? '').trim());

    const handleSubmit = async () => {
        // const config = {
        //         headers: {
        //         'X-Ap-Token': appsetting.token,
        //         'X-Ap-CompanyId': sessionStorage.getItem('CompanyId'),
        //         'X-Ap-UserId': sessionStorage.getItem('UserId'),
        //         }
        //     };     
            try {
              const response = await apiClient.post(`/Manufacturer/UpdateRow`, manufacturer);
              if (response.status === 200) {
                alert('成功');
                fetchData();
              }
            } catch (error) {
              console.error("Error logging in:", error);
              alert('失敗 欄位有誤');
            }          
    }
    const destorySubmit = async (seq) => {
        // const config = {
        //         headers: {
        //         'X-Ap-Token': appsetting.token,
        //         'X-Ap-CompanyId': sessionStorage.getItem('CompanyId'),
        //         'X-Ap-UserId': sessionStorage.getItem('UserId'),
        //         }
        //     };     
            try {
              const response = await apiClient.get(`/Manufacturer/delete/${seq}`);
              if (response.status === 200) {
                alert('成功');
                fetchData();
              }
            } catch (error) {
              console.error("Error logging in:", error);
              alert('失敗 欄位有誤');
            }          
    }

  return (
    <>
    <Box
      sx={{
        margin:'2%',
        width: '95%',
        height: 400,
      }}
    >
       <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <Button variant="text" onClick={()=>setManufacturer({
                        Id:0,
                        Seq:'',
                        BillNum:'',
                        ComPhone:'',
                        ComFax:'',
                        EasyName:'',
                        Boss:'',
                        ComAddress:'',
                        ComFullName:'',
                        ContactPerson:'',
                        AccCode:'',
                        FacPhone:'',
                        FacFax:'',
                        PayWay:'',
                        SendAddress:'',
                        SendAddress2:'',
                        SendAddress3:'',
                        Email:'',
                        Category:'',
                    })}>新增模式</Button>
                </Grid>
                <Grid item xs={3}/>
                <Grid item xs={3}/>
                <Grid item xs={3}/>
                <Grid item xs={3}>
                    <TextField
                        id="manufacturer-seq"
                        label="廠商編號"
                        type="text"
                        value={manufacturer.Seq}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="統一編號"
                     type="search" value={manufacturer.BillNum}
                     onChange={(e) => handleInputChange(e, 'BillNum')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="公司電話"
                     type="search" value={manufacturer.ComPhone}
                     onChange={(e) => handleInputChange(e, 'ComPhone')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="公司傳真"
                     type="search" value={manufacturer.ComFax}
                     onChange={(e) => handleInputChange(e, 'ComFax')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="簡稱"
                     type="search" value={manufacturer.EasyName}
                     onChange={(e) => handleInputChange(e, 'EasyName')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="負責人"
                     type="search" value={manufacturer.Boss}
                     onChange={(e) => handleInputChange(e, 'Boss')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="公司地址"
                     type="search" value={manufacturer.ComAddress}
                     onChange={(e) => handleInputChange(e, 'ComAddress')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="公司名稱"
                     type="search" value={manufacturer.ComFullName}
                     onChange={(e) => handleInputChange(e, 'ComFullName')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="聯絡人"
                     type="search" value={manufacturer.ContactPerson}
                     onChange={(e) => handleInputChange(e, 'ContactPerson')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="會計科目"
                     type="search" value={manufacturer.AccCode}
                     onChange={(e) => handleInputChange(e, 'AccCode')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="工廠電話"
                     type="search" value={manufacturer.FacPhone}
                     onChange={(e) => handleInputChange(e, 'FacPhone')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="工廠傳真"
                     type="search" value={manufacturer.FacFax}
                     onChange={(e) => handleInputChange(e, 'FacFax')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="付款方式"
                     type="search" value={manufacturer.PayWay}
                     onChange={(e) => handleInputChange(e, 'PayWay')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="送貨地址1"
                     type="search" value={manufacturer.SendAddress}
                     onChange={(e) => handleInputChange(e, 'SendAddress')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="送貨地址2"
                     type="search" value={manufacturer.SendAddress2}
                     onChange={(e) => handleInputChange(e, 'SendAddress2')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="送貨地址3"
                     type="search" value={manufacturer.SendAddress3}
                     onChange={(e) => handleInputChange(e, 'SendAddress3')}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField id="outlined-search" label="Email"
                     type="search" value={manufacturer.Email}
                     onChange={(e) => handleInputChange(e, 'Email')}/>
                </Grid>
                <Grid item xs={3} sm={4} md={3}>
  <FormControl
    fullWidth
    sx={{ minWidth: 180 }}
    disabled={categoryDisabled}     // ★ 有廠商編號就鎖住
  >
    <InputLabel id="category-label">廠商分類</InputLabel>
    <Select
      labelId="category-label"
      id="manufacturer-category"
      label="廠商分類"
      value={manufacturer.Category}  // 建議已加到初始 state
      onChange={(e) => handleInputChange(e, 'Category')}
      MenuProps={{ PaperProps: { sx: { maxHeight: 280 }}}}
      sx={{ width: 220 }}
    >
      {CATEGORY_OPTIONS.map(opt => (
        <MenuItem key={opt} value={opt} sx={{ fontSize: 14, py: 1 }}>
          {opt}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>

                {/* 單獨一列：送出新增或修改 */}
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                        <Button variant="contained" onClick={handleSubmit}>送出新增或修改</Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    </Box>
    <Box
  sx={{
    margin: '2%',
    mt: 12,           // ✨ 往下移（可改成 4/8 視覺效果自行調整）
    width: '95%',
    height: 700,
  }}
>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField id="outlined-search" label="簡稱"
                     type="search" value={simple}
                     onChange={(e) => setSimple(e.target.value)}/>
                </Grid>
                <Grid item xs={4}>
                    <TextField id="outlined-search" label="公司名稱"
                     type="search" value={name}
                     onChange={(e) => setName(e.target.value)}/>
                </Grid>
                <Grid item xs={4}>
                    <TextField id="outlined-search" label="聯絡人"
                     type="search" value={person}
                     onChange={(e) => setPerson(e.target.value)}/>
                </Grid>
                <Grid item xs={4}/>
                <Grid item xs={4} style={{display:'flex',justifyContent:'center'}}>
                    <Button variant="text" onClick={fetchFilterData}>搜尋</Button>
                </Grid>              
            </Grid>
        <DataGrid
            rows={rows}
            columns={columns}
            onRowDoubleClick={handleGetDetail}
            initialState={{
            pagination: {
                paginationModel: {
                pageSize: 100,
                },
            },
            }}
            rowHeight={38}
            headerHeight={32}
            pageSizeOptions={[100,75,50]}
            disableRowSelectionOnClick
        />
    </Box>
    </>
  );
}
